import { Component, OnInit } from '@angular/core';
import {
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  DateAdapter
} from '@angular/material/core';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import moment from 'moment';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatFormField,
  MatLabel,
  MatSuffix
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

// Custom Date Formats
export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY'
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-resync-dialog',
  templateUrl: './resync-dialog.component.html',
  styleUrls: ['./resync-dialog.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatSuffix
  ]
})
export class ResyncDialogComponent implements OnInit {
  date = new FormControl(moment());
  maxDate = moment(); // Set maximum date to current date

  constructor(public dialogRef: MatDialogRef<ResyncDialogComponent>) {}

  ngOnInit(): void {
    // Initialize with current month/year
    this.date.setValue(moment());
    console.log(
      'ResyncDialogComponent initialized with date:',
      this.date.value?.format('MM/YYYY')
    );
  }

  onDatepickerOpened(): void {
    console.log('Datepicker opened');
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onMonthSelected(event: any, datepicker: any): void {
    // event is a moment object, no need to manually set the format here.
    this.date.setValue(event);
    datepicker.close();
  }

  confirmSelection(): void {
    const selectedDate = this.date.value;
    if (selectedDate) {
      const formattedDate = moment(selectedDate).format('MM/YYYY');
      this.dialogRef.close(formattedDate);
    } else {
      this.dialogRef.close(null);
    }
  }
}
